import React, {useEffect, useState} from 'react'
import {Button, Popover} from "antd"
import styles from './QueryBuilderTabs.module.scss'
import {ReactComponent as VisualiserIcon} from '../../components/query-builder/icons/Visualiser.svg'
import {TableOutlined, CloseCircleOutlined} from "@ant-design/icons"

export enum QUERY_BUILDER_TAB {
    QUERY_BUILDER,
    QUERY_VISUALISER
}

interface QueryBuilderTabsProps {
    currentTab: QUERY_BUILDER_TAB
    setQueryBuilderTab: (queryBuilderTab: QUERY_BUILDER_TAB) => void
    isQueryVisualizerTabEnabled: boolean
    isCohortAnalyser: boolean
}

export const QueryBuilderTabs = ({currentTab, setQueryBuilderTab, isQueryVisualizerTabEnabled, isCohortAnalyser}: QueryBuilderTabsProps) => {

    const [showVisualizationReadyTooltip, setShowVisualizationReadyTooltip] = useState(false)

    useEffect(() => {
        if (isQueryVisualizerTabEnabled && currentTab === QUERY_BUILDER_TAB.QUERY_BUILDER) {
            setShowVisualizationReadyTooltip(true)
        }
        // eslint-disable-next-line
    }, [isQueryVisualizerTabEnabled])

    const handleTabClick = (queryBuilderTab: QUERY_BUILDER_TAB) => {
        setShowVisualizationReadyTooltip(false)
        setQueryBuilderTab(queryBuilderTab)
    }

    const closeVisualizationReadyPopover = (mouseEvent: React.MouseEvent) => {
        setShowVisualizationReadyTooltip(false)
        mouseEvent.stopPropagation()
    }

    return <>
        <div className={styles.queryBuilderTabContainer}>

            <span className={styles.buttonSpan}>
                <Button className={styles.queryBuilderTab}
                        icon={<TableOutlined/>}
                        onClick={() => handleTabClick(QUERY_BUILDER_TAB.QUERY_BUILDER)}>
                {isCohortAnalyser ? 'Cohort Analyser' : 'Query Builder' }
                </Button>
            </span>

            <Popover overlayClassName={styles.queryVisualizerPopover}
                     placement='right' align={{offset: [5, 0]}} visible={isQueryVisualizerTabEnabled && showVisualizationReadyTooltip}
                     trigger={[]}
                     content={
                                <div>
                                    <span><strong>Query Visualization ready!</strong> Switch tabs to view the charts</span>
                                    <CloseCircleOutlined className={styles.popoverClose} onClick={closeVisualizationReadyPopover}/>
                                </div>
                    }
            >
                <span className={styles.buttonSpan}>
                    <Button className={styles.queryVisualizerTab}
                            icon={<VisualiserIcon/>}
                            disabled={!isQueryVisualizerTabEnabled}
                            onClick={() => handleTabClick(QUERY_BUILDER_TAB.QUERY_VISUALISER)}
                    >
                        Query Visualizer
                    </Button>
                </span>
            </Popover>

        </div>
    </>

}